<template>
  <div class="fluid-container">
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
export default class FluidContainer extends Vue {

}
</script>

<style lang="scss">
.fluid-container {
  margin: auto;
  width: 100%;
  max-width: 1260px;

  @include mediaFluid(tablet) {
    padding: 0 20px;
  }
  
  @include mediaFluid(desktop) {
    padding: 0 10px;
  }
}

// IG-1481 Temporary css - will be refactored in next sprint!!!
.fluid-container__grid--two-col {
  display: grid;
  grid-template-columns: 1fr;
  margin: auto;
  width: 100%;
  max-width: 1260px;

  @include mediaFluid(tablet) {
    padding: 0 20px;
  }

  @include mediaFluid(desktop) {
    grid-template-columns: 820px 1fr;
    grid-column-gap: 20px;
    padding: 0 10px;
  }

  .column-left {
    @include mediaFluid(desktop) {
      display: grid;
      grid-row-gap: 20px;
      align-items: start;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FluidContainer.vue